import { achievementScaleMap } from '@/pages/freePlay/Constants';
import { FRONTEND_ROUTES } from '@/services/Constants';
import { SCREEN_SIZES } from '@/shared/Constants';
import { slugify } from '@/services/Helper';
import { FinishedLevel } from '@/pages/freePlay/types';
import { Step } from '@/pages/learningPath/types';

export const getFreePlayCategoryPath = (id: number | string, name: string): string => {
	return FRONTEND_ROUTES.FREE_PLAY_CATEGORY.replace(':id', id.toString()).replace(
		':slug',
		slugify(name),
	);
};

export const getFreePlayExercisePath = (
	categoryName: string,
	categoryId: string,
	exerciseName: string,
	exerciseId: string,
): string => {
	return FRONTEND_ROUTES.FREE_PLAY_EXERCISE.replace(':categoryId', categoryId)
		.replace(':category', slugify(categoryName))
		.replace(':id', exerciseId)
		.replace(':section', slugify(exerciseName));
};

export const getStarsSteps = (total: number): number[] => {
	const steps = [];
	const stepSize = Math.ceil(total / 4);
	for (let i = 0; i <= total; i += stepSize) {
		steps.push(i);
	}
	return steps;
};

export const addFinishedSectionsIntoLevel = (
	levelId: number,
	finishedLevels: FinishedLevel[] | null,
	finishedSections: Step[],
): FinishedLevel[] | null => {
	if (!finishedLevels) {
		return null;
	}
	return finishedLevels.map((level) => {
		if (level.id === levelId) {
			return {
				...level,
				user_learning_path_sections: finishedSections,
			} as FinishedLevel;
		}
		return level;
	});
};

export const getAchievementScaleMap = () => {
	const windowWidth = window.innerWidth;
	if (windowWidth < SCREEN_SIZES.MOBILE) {
		return achievementScaleMap[SCREEN_SIZES.MOBILE];
	} else if (windowWidth < SCREEN_SIZES.TABLET) {
		return achievementScaleMap[SCREEN_SIZES.TABLET];
	} else {
		return achievementScaleMap[SCREEN_SIZES.DESKTOP];
	}
};
